/**
 * Legend — 지도 색상 의미 안내 (전 지역 가능 / 일부 지역 가능).
 *
 * 표시 조건:
 *  - coverage='partial' 시도(예: 경기, 인천)에서만 노출 — 시군구별 가용성이 다르기 때문
 *  - coverage='full' (서울)은 의미 없으므로 메시지로 대체 (RegionMap 라우터에서 분기)
 */

import circleBasicUrl from '@/assets/icons/circle-basic.svg'
import circleOrangeUrl from '@/assets/icons/circle-orange.svg'

import { LegendItem, LegendText, LegendWrapper } from './Legend.styles'

export default function Legend() {
  return (
    <LegendWrapper>
      <LegendItem>
        <img src={circleOrangeUrl} alt='' width={12} height={12} />
        <LegendText>전 지역 가능</LegendText>
      </LegendItem>
      <LegendItem>
        <img src={circleBasicUrl} alt='' width={12} height={12} />
        <LegendText>일부 지역 가능</LegendText>
      </LegendItem>
    </LegendWrapper>
  )
}
